module.exports = __webpack_public_path__ + "img/1.fc7287d5.png";